var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2870",
    "data-name": "Group 2870",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.656,
    height: 19.656,
    viewBox: "0 0 19.656 19.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M0,0H19.656V19.656H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M4,18.2a6.552,6.552,0,0,1,13.1,0H15.466a4.914,4.914,0,0,0-9.828,0Zm6.552-7.371a4.914,4.914,0,1,1,4.914-4.914A4.913,4.913,0,0,1,10.552,10.828Zm0-1.638A3.276,3.276,0,1,0,7.276,5.914,3.275,3.275,0,0,0,10.552,9.19Z",
    transform: "translate(-0.724 -0.181)",
    fill: "#f5ca3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountYellow);
export default __webpack_public_path__ + "static/media/account-yellow.3b7fe857ce802ea80edbc05508c5482a.svg";
export { ForwardRef as ReactComponent };